/** Most entries kept; older ones scroll away. */
const MAX_ENTRIES = 150;
const STORAGE_KEY = 'iw.combatLog';

/**
 * A log of every attack's result (each hit's damage and what made it so), newest at the
 * bottom, on the right of the view. J shows or hides it; the choice is remembered.
 */
export class CombatLog {
  private readonly el: HTMLDivElement;
  private shown = true;
  private visible = true;
  private count = 0;

  constructor() {
    this.el = document.createElement('div');
    this.el.id = 'combat-log';
    this.el.style.cssText =
      'position:fixed;right:14px;top:22%;width:min(420px,40vw);max-height:46vh;overflow-y:auto;padding:8px 10px;background:rgba(10,12,16,.55);color:#e8e4da;font:12px/1.45 system-ui,sans-serif;border-radius:8px;pointer-events:none;z-index:6;scrollbar-width:none';
    const title = document.createElement('div');
    title.textContent = 'Combat log (J hides)';
    title.style.cssText = 'opacity:.6;margin-bottom:4px';
    this.el.appendChild(title);
    document.body.appendChild(this.el);
    try {
      this.shown = localStorage.getItem(STORAGE_KEY) !== 'hidden';
    } catch {
      // No storage (a private window): start shown.
    }
    this.apply();
  }

  /** Add an attack's result: a heading and one line per hit. */
  add(heading: string, lines: string[], color = '#e8e4da'): void {
    const entry = document.createElement('div');
    entry.style.cssText = 'padding:3px 0;border-top:1px solid rgba(255,255,255,.08)';
    const head = document.createElement('div');
    head.textContent = heading;
    head.style.cssText = `font-weight:600;color:${color}`;
    entry.appendChild(head);
    for (const line of lines) {
      const l = document.createElement('div');
      l.textContent = line;
      l.style.cssText = 'padding-left:10px;opacity:.9';
      entry.appendChild(l);
    }
    this.el.appendChild(entry);
    this.count++;
    // The first child is the title.
    while (this.count > MAX_ENTRIES && this.el.children.length > 1) {
      this.el.children[1].remove();
      this.count--;
    }
    this.el.scrollTop = this.el.scrollHeight;
  }

  toggle(): void {
    this.shown = !this.shown;
    try {
      localStorage.setItem(STORAGE_KEY, this.shown ? 'shown' : 'hidden');
    } catch {
      // Not remembered, then.
    }
    this.apply();
  }

  /** Hidden along with the rest of the interface. */
  setVisible(visible: boolean): void {
    if (visible === this.visible) return;
    this.visible = visible;
    this.apply();
  }

  private apply(): void {
    this.el.style.display = this.shown && this.visible ? '' : 'none';
    if (this.shown) this.el.scrollTop = this.el.scrollHeight;
  }
}
